import { FilesUploadButton } from "components/EvtKit/file-upload/FileUploadButton"
import IconImageUpload from "components/EvtKit/icons/IconImageUpload"
import IconImageUploadDisabled from "components/EvtKit/icons/IconImageUploadDisabled"
import Caption from "components/Typography/Caption"

import { memo } from "react"
import styled from "styled-components"

const IconButtonContainer = styled.div`
  width: 46px;
  padding: 4px 6px 4px 6px;
  border-radius: 4px;
  box-shadow: 0px 2px 6px 0px #0000001a;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

interface IconButtonImageUploadProps {
  disabled?: boolean
}

const IconButtonImageUpload = (props: IconButtonImageUploadProps) => {
  const { disabled } = props

  const icon = disabled ? <IconImageUploadDisabled /> : <IconImageUpload />

  return (
    <FilesUploadButton disabled={disabled}>
      <IconButtonContainer>
        {icon}
        <Caption size="medium" weight="regular" color={disabled ? "gray-medium" : "primary-dark"}>
          Upload
        </Caption>
      </IconButtonContainer>
    </FilesUploadButton>
  )
}

export default memo(IconButtonImageUpload)
